export const displayRecruiterIfAvailable = () => {
    const body = document.querySelector(".job-details");

    if (!body) return;

    const profileWidgetWithRecruiter: HTMLElement | null =
        document.querySelector(
            ".attrax-social-hub-profile-widget__profile-link"
        );

    if (profileWidgetWithRecruiter) {
        const parent: HTMLElement | null =
            profileWidgetWithRecruiter.parentElement;
        if (parent) {
            parent.style.display = "flex";
        }
    }
};
